// Login data must not outlive the last open tab. On pagehide each tab moves localStorage into its
// own sessionStorage (kept on refresh, deleted by the browser on close); tabs still open write back
// their in-memory copy when they see the clear (see App.js).
const STASH_KEY = 'ima360SessionStash';
// Restoring loggedIn='false' would fire the cross-tab logout listener in other tabs ('true' must be kept).
const isLogoutFlag = (key, value) => key === 'loggedIn' && value === 'false';

export function mergeIntoLocalStorage(entries) {
  Object.entries(entries || {}).forEach(([key, value]) => {
    if (!isLogoutFlag(key, value) && localStorage.getItem(key) === null) {
      localStorage.setItem(key, value);
    }
  });
}

export function readLocalStorage() {
  const snapshot = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    const value = localStorage.getItem(key);
    if (!isLogoutFlag(key, value)) snapshot[key] = value;
  }
  return snapshot;
}

// `fallback` fills keys another tab's clear removed before this tab could restore them.
export function stashLocalStorage(fallback = {}) {
  sessionStorage.setItem(STASH_KEY, JSON.stringify({ ...fallback, ...readLocalStorage() }));
  localStorage.clear();
}

export function restoreStash() {
  const stashed = sessionStorage.getItem(STASH_KEY);
  if (!stashed) return;
  sessionStorage.removeItem(STASH_KEY);
  mergeIntoLocalStorage(JSON.parse(stashed));
}

// Runs on import. App.js imports this first, before react-secure-storage reads localStorage.
try {
  restoreStash();
} catch (error) {
  console.error('[sessionStash]', error);
}
